// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const attempt = <T extends (...args: any[]) => any>(fn: T, fallback: ReturnType<T>): ReturnType<T> => {
  try {
    return fn();
  } catch (error) {
    return fallback;
  }
};
